export const RAREPEPE_EMBLEM_TOKEN = '52797273465606109053260334516277720123594475882126304335661589339357462454990';
export const RAREPEPE_OPENSEA_URL = `https://opensea.io/item/ethereum/0x7e6027a6a84fc1f6db6782c523efe62c923e46ff/${RAREPEPE_EMBLEM_TOKEN}`;
export const RAREPEPE_VAULTS_URL = `https://v2.emblemvault.io/allBackingIdsForTokenId/${RAREPEPE_EMBLEM_TOKEN}`;

export function normalizeVaults(records) {
  if (!Array.isArray(records)) throw new Error('invalid_vault_response');
  const seen = new Set();
  return records.map(record => {
    // Token IDs exceed Number.MAX_SAFE_INTEGER. Preserve the API's decimal strings.
    if (typeof record?.tokenId !== 'string' || !/^[0-9]{1,78}$/.test(record.tokenId) ||
        typeof record.address !== 'string' || !/^[a-zA-Z0-9]{26,90}$/.test(record.address)) throw new Error('invalid_vault_record');
    const owner = typeof record.owner === 'string' && /^0x[0-9a-f]{40}$/i.test(record.owner) ? record.owner : null;
    return { address: record.address, tokenId: record.tokenId, owner, url: `https://emblem.vision/vault/${record.tokenId}` };
  }).filter(record => {
    const key = `${record.address}:${record.tokenId}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export function cardsForAddress(query, locations, vaults) {
  const address = String(query || '').trim();
  const ethereum = /^0x[0-9a-f]{40}$/i.test(address);
  return Object.entries(locations || {}).filter(([serial, location]) => ethereum
    ? (vaults[serial] || []).some(vault => vault.owner?.toLowerCase() === address.toLowerCase())
    : location.kind === 'address' && location.id === address
  ).map(([serial]) => Number(serial)).sort((a, b) => a - b);
}

export const isAddressQuery = query => /^(?:0x[0-9a-f]{40}|[13][a-zA-Z0-9]{25,34}|bc1[a-zA-Z0-9]{20,87})$/i.test(String(query || '').trim());

export function hasCurrentLocations(context) {
  return context?.complete === true && context.fresh === true &&
    !context.archive_error && !context.projection_error;
}

export function matchingVaults(location, records) {
  // An escrow controller may be a vault address without the card being in that vault.
  if (location?.kind !== 'address') return [];
  return (records || []).filter(record => record.address === location.id);
}

export function expandCardLocations(items) {
  const locations = {};
  for (const item of items) {
    const first = Number(item.range?.first);
    const last = Number(item.range?.last);
    const quantity = Number(item.range?.quantity);
    if (item.asset !== 'RAREPEPE' || !Number.isInteger(first) || !Number.isInteger(last) ||
        Math.min(first, last) < 1 || Math.max(first, last) > 300 ||
        quantity !== Math.abs(last - first) + 1 || !item.location?.kind || !item.location?.id) throw new Error('invalid_card_range');
    for (let serial = Math.min(first, last); serial <= Math.max(first, last); serial++) {
      if (locations[serial]) throw new Error('duplicate_card_location');
      locations[serial] = item.location;
    }
  }
  if (Object.keys(locations).length !== 300) throw new Error('incomplete_card_locations');
  return locations;
}
